import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CourseCard from './components/CourseCard';
// import InstructorCard from './components/InstructorCard';
// import ProjectCard from './components/ProjectCard';
import RegisterModal from './components/RegisterModal';
import './index.css';
import { courses } from '../data';

const Home = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleEnrollClick = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <Navbar handleEnrollClick={handleEnrollClick} />
      <Hero />

      <section id="free-tools" className="section" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
        <h2>🎨 Free Professional Tools</h2>
        <p>Access 11 powerful creative tools - no sign-up required!</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1.5rem', marginTop: '2rem' }}>

          <Link to="/tools/image-to-video" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: 'white' }}>🎬 Image to Animation Video</h3>
              <p style={{ color: 'rgba(255,255,255,0.9)' }}>Create stunning animated videos from your images with 12 transition effects</p>
            </div>
          </Link>

          <Link to="/tools/qr-generator" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: 'white' }}>📱 QR Code Generator</h3>
              <p style={{ color: 'rgba(255,255,255,0.9)' }}>Generate custom QR codes with adjustable colors and sizes</p>
            </div>
          </Link>

          <Link to="/tools/color-picker" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: 'white' }}>🎨 Color Picker & Converter</h3>
              <p style={{ color: 'rgba(255,255,255,0.9)' }}>Pick colors and convert between HEX, RGB, RGBA, and HSL formats</p>
            </div>
          </Link>

          <Link to="/tools/password-generator" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: 'white' }}>🔐 Password Generator</h3>
              <p style={{ color: 'rgba(255,255,255,0.9)' }}>Create secure passwords with customizable length and character types</p>
            </div>
          </Link>

          <Link to="/tools/image-compressor" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: 'white' }}>🗜️ Image Compressor</h3>
              <p style={{ color: 'rgba(255,255,255,0.9)' }}>Reduce image file sizes while maintaining quality</p>
            </div>
          </Link>

          <Link to="/tools/text-to-speech" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: 'white' }}>🔊 Text to Speech</h3>
              <p style={{ color: 'rgba(255,255,255,0.9)' }}>Convert text to natural-sounding speech with voice options</p>
            </div>
          </Link>

          <Link to="/tools/image-to-pdf" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: '#1f2937' }}>📄 Image to PDF</h3>
              <p style={{ color: '#374151' }}>Convert multiple images into a single PDF document</p>
            </div>
          </Link>

          <Link to="/tools/pdf-to-images" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: '#1f2937' }}>🖼️ PDF to Images</h3>
              <p style={{ color: '#374151' }}>Extract individual pages from PDF files as images</p>
            </div>
          </Link>

          <Link to="/tools/video-trimmer" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: '#1f2937' }}>✂️ Video Trimmer</h3>
              <p style={{ color: '#374151' }}>Trim and cut your videos with precise timeline controls</p>
            </div>
          </Link>

          <Link to="/tools/background-remover" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #fdcbf1 0%, #e6dee9 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: '#1f2937' }}>🎭 Background Remover</h3>
              <p style={{ color: '#374151' }}>Remove backgrounds from images and save as transparent PNG</p>
            </div>
          </Link>

          <Link to="/tools/audio-visualizer" className="card" style={{ textDecoration: 'none', color: 'inherit', background: 'linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', transition: 'transform 0.2s' }}>
            <div className="card-content">
              <h3 style={{ color: '#1f2937' }}>🎵 Audio Visualizer</h3>
              <p style={{ color: '#374151' }}>Create stunning visual animations for your audio files</p>
            </div>
          </Link>

        </div>
      </section>

      <section id="courses" className="section gray">
        <h2>Our Top Courses</h2>
        <p>Learn from industry experts and build real-world projects</p>
        <div className="cards-grid">
          {courses.map((course, i) => (
            <CourseCard key={i} course={course} onEnroll={handleEnrollClick} />
          ))}
        </div>
      </section>

      {/* <section id="instructors" className="section gray">
        <h2>Meet Our Expert Instructors</h2>
        <p>Learn from industry professionals with years of real-world experience</p>
        <div className="cards-grid">
          {instructors.map((inst, i) => (
            <InstructorCard key={i} instructor={inst} />
          ))}
        </div>
      </section>

      <section id="projects" className="section">
        <h2>Hands-On Projects</h2>
        <p>Apply your skills to real-world projects and build an impressive portfolio</p>
        <div className="cards-grid">
          {projects.map((proj, i) => (
            <ProjectCard key={i} project={proj} />
          ))}
        </div>
      </section> */}

      <footer>
        <div className="logo">TECH WALA</div>
        <p>
          Empowering the next generation of developers through hands-on learning and real-world
          projects.
        </p>
        <div className="copyright">
          © 2025 Tech Wala Online Academy. All rights reserved.
        </div>
      </footer>

      {/* ✅ Student Registration Modal */}
      <RegisterModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default Home;
